import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, of, throwError, BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  apiBaseUrl = environment.apiBaseUrl;
  private refreshAttempted = false;  // Flag to avoid repeated refresh attempts
  private refreshFailed = false;
  private accessToken: string | null = null;
  private loggedOut = false;

  // BehaviorSubject to track login state, default false (not logged in)
  private loggedInSubject = new BehaviorSubject<boolean>(false);
  loggedIn$ = this.loggedInSubject.asObservable();

  http = inject(HttpClient);

  constructor() {}

  // Centralized setter for access token that also updates login state
  private setAccessToken(token: string | null) {
    this.accessToken = token;
    this.loggedInSubject.next(!!token);
  }

  setToken(email: string, password: string): Observable<void> {
    this.loggedOut = false; // Reset logged out flag on successful login
    return this.http.post<{ access_token: string }>(
      `${this.apiBaseUrl}/auth/login`,
      { email, password },
      { withCredentials: true }
    ).pipe(
      tap(res => {
        this.setAccessToken(res.access_token);
      }),
      map(() => void 0)
    );
  }

  getToken(): string | null {
    // console.log('Current access token:', this.accessToken);
    return this.accessToken;
  }

  logout(): Observable<void> {
    return this.http.post(`${this.apiBaseUrl}/auth/logout`, {}, { withCredentials: true }).pipe(
      tap(() => {
        this.loggedOut = true;           // Only mark logged out after successful API call
        this.setAccessToken(null);       // Clear access token and update state
      }),
      map(() => void 0)
    );
  }

  checkAuthOnStartup(): Observable<boolean> {
    return this.refreshToken().pipe(
      map(() => true),
      catchError(() => {
        this.setAccessToken(null);
        return of(false);
      })
    );
  }
  refreshToken(): Observable<string> {
    // console.log('User is logged out: ' + this.loggedOut);

    if (this.loggedOut) {
      // If logged out, skip refresh token call and throw error immediately
      return throwError(() => new Error('User logged out, no refresh'));
    }

    return this.http.post<{ access_token: string }>(
      `${this.apiBaseUrl}/auth/refresh`,
      {},
      { withCredentials: true }
    ).pipe(
      tap(res => {
        // console.log(res.access_token);
        this.setAccessToken(res.access_token);
      }),
      map(res => res.access_token),
      catchError(err => {
        this.loggedOut = true;
        // console.error('Refresh token error:', err);
        return throwError(() => err);
      })
    );
  }

  getLoggedOut() {
    return this.loggedOut;
  }

  // checkAuthOnStartup(): Observable<boolean> {
  //   return this.refreshToken().pipe(
  //     map(() => true),
  //     catchError(() => of(false))
  //   );
  // }

}
